export default "__VITE_ASSET__ruw0kWuP__"